import React, { Component } from 'react';
import { Control, Form } from 'react-redux-form';
import validators from '../../helpers/validators';

import OrderList from '../ui/ordered-list';
import UnorderList from '../ui/unordered-list';
import Headline from '../ui/headline';
import Accordion from '../ui/accordion';
import Textfield from '../ui/text-field';
import Textarea from '../ui/textarea';
import Select from '../ui/select';
import Checkbox from '../ui/checkbox';
import Radio from '../ui/radio';
import Rating from '../ui/rating';
import Modal from '../ui/modal';
import Datepicker from '../ui/datepicker';

class Styleguide extends Component {
    constructor(props) {
        super(props);
        //For accordion example
        this.accordionData = [
            {
                title: 'Title 1',
                content:
                    'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet eligendi laudantium sunt. A adipisci cupiditate debitis delectus dolorem molestiae quibusdam similique soluta temporibus voluptatibus. Cum repellat repellendus rerum velit vitae.'
            },
            {
                title: 'Title 2',
                content:
                    'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet eligendi laudantium sunt. A adipisci cupiditate debitis delectus dolorem molestiae quibusdam similique soluta temporibus voluptatibus. Cum repellat repellendus rerum velit vitae.'
            },
            {
                title: 'Title 3',
                content:
                    'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet eligendi laudantium sunt. A adipisci cupiditate debitis delectus dolorem molestiae quibusdam similique soluta temporibus voluptatibus. Cum repellat repellendus rerum velit vitae.'
            }
        ];

        this.tabsContent = [
            {
                path: 'title-one',
                title: <div>Title one</div>,
                content: <h1>Content 1</h1>
            },
            {
                path: 'title-two',
                title: 'Title 2',
                content: 'Content 2'
            },
            {
                path: 'title-three',
                title: 'Title 3',
                content: 'Content 3'
            },
            {
                path: 'title-four',
                title: 'Title 4',
                content: 'Content 4'
            }
        ];
    }

    handleSubmit = e => {
        console.log(e);
    };

    render() {
        const required = validators.required();
        const emailMessage = 'This is not a valid email address.';
        const checkbox = validators.checkbox();
        return (
            <div>
                <h3>Styleguide</h3>
                <Form model="user" onSubmit={this.handleSubmit}>
                    <Textfield
                        model="user.firstName"
                        isRequired
                        title="First Name"
                        validators={{ required }}
                        messages={{ required: required.message }}
                    />
                    <Textfield
                        model="user.email"
                        isRequired
                        title="Email"
                        type="email"
                        validators={{ required }}
                        messages={{
                            required: required.message,
                            typeMismatch: emailMessage
                        }}
                    />

                    <Textfield
                        model="user.number"
                        isRequired
                        title="Number"
                        type="number"
                        validators={{ required }}
                        messages={{ required: required.message }}
                    />

                    <Textarea
                        model="user.message"
                        isRequired
                        title="Message"
                        validators={{ required }}
                        messages={{ required: required.message }}
                    />

                    <Select
                        model="user.options"
                        isRequired
                        title="Select"
                        options={[
                            { name: 'Select 1', code: '1' },
                            { name: 'Select 2', code: '2' },
                            { name: 'Select 3', code: '3' }
                        ]}
                        validators={{ required }}
                        messages={{ required: required.message }}
                    />

                    <Checkbox
                        model="user.checkbox[]"
                        isRequired
                        title="Checkboxes"
                        options={[
                            { name: 'Check box 1', code: '1' },
                            { name: 'Check box 2', code: '2' },
                            { name: 'Check box 3', code: '3' }
                        ]}
                        validators={{ checkbox }}
                        messages={{ checkbox: checkbox.message }}
                    />

                    <Radio
                        model="user.radio"
                        isRequired
                        title="Radios"
                        options={[
                            { name: 'Radio 1', code: '1' },
                            { name: 'Radio 2', code: '2' },
                            { name: 'Radio 3', code: '3' }
                        ]}
                        validators={{ required }}
                        messages={{ required: required.message }}
                    />

                    <Rating model="user.rating" />

                    <Datepicker
                        model="user.date"
                        isRequired
                        id="custom-datepicker"
                        title="Pick A Date"
                    />

                    <Datepicker
                        model="user.startDate"
                        isRequired
                        id="custom-datepicker-startDate"
                        title="Pick A Date"
                        selectsStart
                    />

                    <Datepicker
                        model="user.endDate"
                        isRequired
                        id="custom-datepicker-endDate"
                        title="Pick A Date"
                        selectsEnd
                    />

                    <div className="form__row">
                        <button className="form__submit" type="submit">
                            Submit
                        </button>
                        <Control.reset
                            className="btn btn--secondary"
                            model="user"
                            type="reset"
                        >
                            Reset
                        </Control.reset>
                    </div>
                </Form>

                <Accordion data={this.accordionData} />

                <Headline title="Testing Title" tagValue="1" />
                <Headline title="Header One" tagValue="1" />
                <Headline title="Header Two" tagValue="2" />
                <Headline title="Header Three" tagValue="3" />
                <Headline title="Header Four" tagValue="4" />
                <Headline title="Header Five" tagValue="5" />
                <Headline title="Header Six" tagValue="6" />

                <OrderList
                    content={['Order List 1', 'Order List 2', 'Order List 3']}
                />
                <UnorderList
                    content={[
                        'Unorder List 1',
                        'Unorder List 2',
                        'Unorder List 3'
                    ]}
                />

                <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                    Amet eligendi laudantium sunt. A adipisci cupiditate debitis
                    delectus dolorem molestiae quibusdam similique soluta
                    temporibus voluptatibus. Cum repellat repellendus rerum
                    velit vitae.
                </p>

                {/*Modal*/}
                <Modal title="Open First Modal" classes="btn align-left">
                    <Headline title="Header One" tagValue="1" />
                    <p>What ever you want to put here</p>
                </Modal>

                {/*Modal*/}
                <Modal title="Open Second Modal" classes="btn align-left">
                    <Headline title="Second Modal" tagValue="1" />
                    <p>Sample Second Modal</p>
                </Modal>
            </div>
        );
    }
}

export default Styleguide;



// WEBPACK FOOTER //
// ./src/components/styleguide/index.js